import React from "react";
import styled from "styled-components";
import { Button } from "antd";
import { coupleImg, familyImg, adventureImg, luxuryImg } from "./Common";

const Category = styled.div`
  padding-top: 7rem;
  padding-left: 8rem;
  padding-right: 8rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const CategoryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
`;

const CategoryCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.5rem;
  border-radius: 16px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 250px;
  justify-content: flex-end;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
    border-radius: 16px;
    z-index: 1;
  }
`;

const CardContent = styled.div`
  position: relative;
  z-index: 2;
`;

const Text2 = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  color: #ffffff;
`;

const Text3 = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #ffffff;
`;

const ExploreButton = styled(Button)`
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 15px;
  margin-top: 1rem;
  font-weight: 500;
  width: fit-content;

  &:hover {
    background: #40a9ff !important;
    color: white !important;
  }
`;

const SmallHeader = styled.h2`
  text-align: left;
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 100%;
`;

const CategorySection: React.FC = () => {
  return (
    <Category>
      <SmallHeader>Browse by Category</SmallHeader>
      <CategoryContainer>
        <CategoryCard style={{ backgroundImage: `url(${coupleImg})` }}>
          <CardContent>
            <Text2>Couples</Text2>
            <Text3>Romantic getaways, spa days, private dining</Text3>
            <ExploreButton>Explore</ExploreButton>
          </CardContent>
        </CategoryCard>
        <CategoryCard style={{ backgroundImage: `url(${familyImg})` }}>
          <CardContent>
            <Text2>Family</Text2>
            <Text3>Kid-friendly activities, theme parks, zoos</Text3>
            <ExploreButton>Explore</ExploreButton>
          </CardContent>
        </CategoryCard>
        <CategoryCard style={{ backgroundImage: `url(${adventureImg})` }}>
          <CardContent>
            <Text2>Adventure</Text2>
            <Text3>Hiking, water sports, extreme activities</Text3>
            <ExploreButton>Explore</ExploreButton>
          </CardContent>
        </CategoryCard>
        <CategoryCard style={{ backgroundImage: `url(${luxuryImg})` }}>
          <CardContent>
            <Text2>Luxury</Text2>
            <Text3>VIP experiences, private tours, premium services</Text3>
            <ExploreButton>Explore</ExploreButton>
          </CardContent>
        </CategoryCard>
      </CategoryContainer>
    </Category>
  );
};

export default CategorySection;
